/**
 * Tracking category constants
 * Format: <context>_<action_type>
 *
 * Contexts: app, player, playback, tealium
 * Action Types: view, interact, display, operation, log, ads, content
 */

// App context categories
export const APP_VIEW = 'app_view';
export const APP_INTERACT = 'app_interact';
export const APP_DISPLAY = 'app_display';
export const APP_OPERATION = 'app_operation';
export const APP_LOG = 'app_log';
export const APP_ADS = 'app_ads';
export const APP_CONTENT = 'app_content';

/**
 * Grouped tracking categories by context
 */
export const TrackingCategory = {
    App: {
        VIEW: APP_VIEW,
        INTERACT: APP_INTERACT,
        DISPLAY: APP_DISPLAY,
        OPERATION: APP_OPERATION,
        LOG: APP_LOG,
        ADS: APP_ADS,
        CONTENT: APP_CONTENT,
    },
} as const;

/**
 * Type union of all valid tracking categories
 */
export type TrackingCategoryType =
    | typeof APP_VIEW
    | typeof APP_INTERACT
    | typeof APP_DISPLAY
    | typeof APP_OPERATION
    | typeof APP_LOG
    | typeof APP_ADS
    | typeof APP_CONTENT;
